import { Badge, Box, Group, Stack, Text } from '@mantine/core';

const NameCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Stack gap={0}>
                <Text>{rowData.imeiPrefix}</Text>
            </Stack>
        </Box>
    );
};

const PrefixColumn = () => ({
    accessorKey: 'iccidPrefix',
    header: 'Imei Prefix',
    size: 2,
    minSize: 200,
    Cell: ({ cell }) => <NameCell cell={cell} />,
});
export default PrefixColumn;
